import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/useAuth';
import { usePageTitle } from '@/components/usePageTitle';
import { AssistantAccess } from '@/features/auth/AssistantAccess';
import { ClientShell } from '@/shells/ClientShell';

export const Route = createFileRoute('/_client/assistant-access')({ component: AssistantAccessPage });

function AssistantAccessPage() {
  const { t } = useTranslation();
  usePageTitle(t('nav.assistantAccess'));
  const { me } = useAuth();
  return (
    <ClientShell eyebrow={me?.email} title={t('nav.assistantAccess')} lead={t('assistant.lead')}>
      <AssistantAccess isStaff={!!me?.is_staff} />
    </ClientShell>
  );
}
